import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import Product from '@/models/Products/Product';
import GeneralLedgerMappings from '@/models/Products/ProductGeneralLedgerMapping/GeneralLedgerMappings';
import GeneralLedgerMappingOverride from '@/models/Products/ProductGeneralLedgerMapping/GeneralLedgerMappingOverride';
import { AppModule } from '@/store/Auth/AppModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import ProductFeatureVisiblity from '@/models/Products/ProductFeatureVisiblity';
import ListUtils from '@/lib/listUtils';
import CurrencyUtils from "@/lib/currencyUtils";
import PermissionUtils from '@/lib/permissionUtils';
import UpdateDepositBankSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/Banking/UpdateDepositBankSettingsRequest';
import EditProductViewModel from '@/models/Products/EditProductViewModel';
import UpdateGeneralPayeeSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/GeneralPayee/UpdateGeneralPayeeSettingsRequest';
import UpdateDepositCardSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/Cards/UpdateDepositCardSettingsRequest';
import UpdateDepositPaymentOrderSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/PaymentOrders/UpdateDepositPaymentOrderSettingsRequest';
import UpdateDepositInterestSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/DepositInterest/UpdateDepositInterestSettingsRequest';
import UpdateDepositInstantAccessSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/InstantAccess/UpdateDepositInstantAccessSettingsRequest';
import UpdateDepositOverdraftSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/Overdraft/UpdateDepositOverdraftSettingsRequest';
import UpdateDepositOverdraftInterestSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/OverdraftInterest/UpdateDepositOverdraftInterestSettingsRequest';
import UpdateDepositCoolingOffSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/CoolingOff/UpdateDepositCoolingOffSettingsRequest';
import UpdateLendingInterestSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/LendingInterest/UpdateLendingInterestSettingsRequest';
import UpdateLendingScheduleSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/Schedule/UpdateLendingScheduleSettingsRequest';
import UpdateLendingTermSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/Term/UpdateLendingTermSettingsRequest';
import UpdateProductGeneralLedgerSettingsRequest from '@/models/Products/ProductSettings/UpdateProductGeneralLedgerSettingsRequest';
import UpdateProductGeneralSettingsRequest from '@/models/Products/ProductSettings/UpdateProductGeneralSettingsRequest';
import CreateGeneralLedgerMappingsRequest from '@/models/Products/Wizard/CreateGeneralLedgerMappingsRequest';
import UpdateGeneralFeeSettingsRequest from '@/models/Products/ProductFees/UpdateGeneralFeeSettingsRequest';
import GetHistoryResponse from '@/models/Shared/GetHistoryResponse';
import HistoryEntry from '@/models/Shared/HistoryEntry';
import HistoryUtils from '@/lib/HistoryUtils';
import CreateGeneralLedgerMappingOverridesRequest from '@/models/Products/ProductGeneralLedgerMapping/CreateGeneralLedgerMappingOverridesRequest';
import UpdateGeneralLedgerMappingOverrideRequest from '@/models/Products/ProductGeneralLedgerMapping/UpdateGeneralLedgerMappingOverrideRequest';
import CreateProductIssueRequest from '@/models/Products/ProductIssues/CreateProductIssueRequest';
import ProductIssue from '@/models/Products/ProductIssues/ProductIssue';
import CustomerAccountSummary from '@/models/Accounts/DepositAccounts/DepositAccountSummary';
import RateSource from '@/models/Products/RateSources/RateSource';
import GeneralFeeSettings from '@/models/Products/ProductFees/GeneralFeeSettings';
import ProductGeneralLedgerSettings from '@/models/Products/ProductSettings/ProductGeneralLedgerSettings';
import GeneralPayeeSettings from '@/models/Products/ProductSettings/DefaultSettings/GeneralPayee/GeneralPayeeSettings';
import DepositBankSettings from '@/models/Products/ProductSettings/DefaultSettings/Banking/DepositBankSettings';
import DepositCardSettings from '@/models/Products/ProductSettings/DefaultSettings/Cards/DepositCardSettings';
import DepositPaymentOrderSettings from '@/models/Products/ProductSettings/DefaultSettings/PaymentOrders/DepositPaymentOrderSettings';
import DepositInterestSettings from '@/models/Products/ProductSettings/DefaultSettings/DepositInterest/DepositInterestSettings';
import DepositInstantAccessSettings from "@/models/Products/ProductSettings/DefaultSettings/InstantAccess/DepositInstantAccessSettings";
import DepositOverdraftSettings from '@/models/Products/ProductSettings/DefaultSettings/Overdraft/DepositOverdraftSettings';
import DepositOverdraftInterestSettings from '@/models/Products/ProductSettings/DefaultSettings/OverdraftInterest/DepositOverdraftInterestSettings';
import DepositFixedTermSettings from '@/models/Products/ProductSettings/DefaultSettings/FixedTerm/DepositFixedTermSettings';
import DepositFixedTermMaturitySettings from '@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/DepositFixedTermMaturitySettings';
import DepositCoolingOffSettings from "@/models/Products/ProductSettings/DefaultSettings/CoolingOff/CoolingOffSettings";
import UpdateDepositFixedTermSettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/FixedTerm/UpdateDepositFixedTermSettingsRequest';
import UpdateDepositFixedTermMaturitySettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/UpdateDepositFixedTermMaturitySettingsRequest';
import SecondaryWalletType from '@/models/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletType';
import CreateTransactionalFeeRequest from '@/models/Products/ProductFees/CreateTransactionalFeeRequest';
import CreateScheduledFeeRequest from '@/models/Products/ProductFees/CreateScheduledFeeRequest';
import CreateManualFeeRequest from '@/models/Products/ProductFees/CreateManualFeeRequest';
import CreateSecondaryWalletTypeRequest from '@/models/Products/ProductSettings/SecondaryWallets/General/CreateSecondaryWalletTypeRequest';
import TransactionalFee from '@/models/Products/ProductFees/TransactionalFee';
import ScheduledFee from '@/models/Products/ProductFees/ScheduledFee';
import ManualFee from '@/models/Products/ProductFees/ManualFee';
import UpdateScheduledFeeRequest from '@/models/Products/ProductFees/UpdateScheduledFeeRequest';
import UpdateTransactionalFeeRequest from '@/models/Products/ProductFees/UpdateTransactionalFeeRequest';
import UpdateManualFeeRequest from '@/models/Products/ProductFees/UpdateManualFeeRequest';
import UpdateSecondaryWalletSettingsRequest from '@/models/Products/ProductSettings/SecondaryWallets/General/UpdateSecondaryWalletSettingsRequest';
import UpdateSecondaryWalletTypeGeneralSettingsRequest from '@/models/Products/ProductSettings/SecondaryWallets/General/UpdateSecondaryWalletTypeGeneralSettingsRequest';
import UpdateSecondaryWalletTypeInterestSettingsRequest from '@/models/Products/ProductSettings/SecondaryWallets/Savings/UpdateSecondaryWalletTypeInterestSettingsRequest';
import SecondaryWalletTypeViewModel from '@/models/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletTypeViewModel';
import SecondaryWalletSettings from '@/models/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletSettings';
import LendingBankSettings from '@/models/Products/ProductSettings/DefaultSettings/Banking/LendingBankSettings';
import LendingCardSettings from '@/models/Products/ProductSettings/DefaultSettings/Cards/LendingCardSettings';
import LendingInterestSettings from '@/models/Products/ProductSettings/DefaultSettings/LendingInterest/LendingInterestSettings';
import LendingScheduleSettings from '@/models/Products/ProductSettings/DefaultSettings/Schedule/LendingScheduleSettings';
import LendingTermSettings from '@/models/Products/ProductSettings/DefaultSettings/Term/LendingTermSettings';
import LendingRepaymentPlansSettings from '@/models/Products/ProductSettings/DefaultSettings/RepaymentPlans/LendingRepaymentPlansSettings';

export interface IProductDetailsState {
    loading: boolean;
    loadingDialog: boolean;
    loadingHistory: boolean;
    loadingProductIssues: boolean;
    product: Product;
    generalLedgerMappings: GeneralLedgerMappings;
    generalLedgerMappingOverrides: GeneralLedgerMappingOverride[];
    totalGeneralLedgerMappingOverridesPages: number;
    currentGeneralLedgerMappingOverride: GeneralLedgerMappingOverride;
    productVM: EditProductViewModel;
    productIssues: ProductIssue[];
    totalProductIssuesPages: number;
    productAccounts: CustomerAccountSummary[];
    totalProductAccountsPages: number;
    currentProductIssue: ProductIssue;
    newProductIssueId: string;
    currentTransactionalFee: TransactionalFee;
    currentScheduledFee: ScheduledFee;
    currentManualFee: ManualFee;
    totalTransactionalFeesPages: number;
    totalScheduledFeesPages: number;
    totalManualFeesPages: number;
    productFeatureVisibility: ProductFeatureVisiblity;
    history: HistoryEntry[];
    rateSources: RateSource[];
    currentSecondaryWallet: SecondaryWalletType;
    currentSecondaryWalletTypeViewModel: SecondaryWalletTypeViewModel;
    pageSize: number;
}

@Module({ dynamic: true, store, name: 'ProductDetailsModule', namespaced: true })
class ProductDetailsStore extends VuexModule implements IProductDetailsState {

    public loading: boolean = true;
    public loadingDialog: boolean = false;
    public loadingHistory: boolean = false;
    public loadingProductIssues: boolean = false;
    public product: Product = new Product();
    public generalLedgerMappings: GeneralLedgerMappings = new GeneralLedgerMappings();
    public generalLedgerMappingOverrides: GeneralLedgerMappingOverride[] = [];
    public totalGeneralLedgerMappingOverridesPages: number = 1;
    public currentGeneralLedgerMappingOverride: GeneralLedgerMappingOverride = new GeneralLedgerMappingOverride()
    public productVM: EditProductViewModel = new EditProductViewModel();
    public productIssues: ProductIssue[] = [];
    public totalProductIssuesPages: number = 1;
    public productAccounts: CustomerAccountSummary[] = [];
    public totalProductAccountsPages: number = 1;
    public currentProductIssue: ProductIssue = new ProductIssue()
    public newProductIssueId: string = null;
    public currentTransactionalFee: TransactionalFee = new TransactionalFee();
    public currentScheduledFee: ScheduledFee = new ScheduledFee();
    public currentManualFee: ManualFee = new ManualFee();
    public totalTransactionalFeesPages: number = 1;
    public totalScheduledFeesPages: number = 1;
    public totalManualFeesPages: number = 1;
    public productFeatureVisibility = new ProductFeatureVisiblity();
    public history: HistoryEntry[] = [];
    public rateSources: RateSource[] = [];
    public currentSecondaryWallet: SecondaryWalletType = new SecondaryWalletType();
    public currentSecondaryWalletTypeViewModel: SecondaryWalletTypeViewModel = new SecondaryWalletTypeViewModel(new SecondaryWalletType());
    public pageSize: number = PermissionUtils.getPageSize();

    @Action
    async getProduct(id: string) {

        this.setLoading(true);

        await ajax.get(`/portal-backend/fi-api/internal/products/${id}`)
        .then(response => {
            this.context.commit("setProduct", response.data);

            // If any of the fee types are present in the product then preselect
            // them as the current fee, otherwise reset the fee back to empty
            if (response.data.generalFeeSettings) {
                const { transactionalFees, scheduledFees, manualFees } = response.data.generalFeeSettings;
                if (transactionalFees?.length > 0) {
                    this.context.commit("setCurrentTransactionalFee", transactionalFees[0]);
                    this.context.commit("setTransactionalFeesTotalPages", transactionalFees.length);
                }
                else {
                    this.context.commit("setCurrentTransactionalFee", new TransactionalFee);
                    this.context.commit("setTransactionalFeesTotalPages", 0);
                }
                if (scheduledFees?.length > 0) {
                    this.context.commit("setCurrentScheduledFee", scheduledFees[0]);
                    this.context.commit("setScheduledFeesTotalPages", scheduledFees.length);
                }
                else {
                    this.context.commit("setCurrentScheduledFee", new ScheduledFee);
                    this.context.commit("setScheduledFeesTotalPages", 0);
                }
                if (manualFees?.length > 0) {
                    this.context.commit("setCurrentManualFee", manualFees[0]);
                    this.context.commit("setManualFeesTotalPages", manualFees.length);
                }
                else {
                    this.context.commit("setCurrentManualFee", new ManualFee);
                    this.context.commit("setManualFeesTotalPages", 0);
                }
            }

            // If any secondary wallets are present in the product then preselect
            // the first one that is available, otherwise reset the selected wallet back to empty
            if (response.data.secondaryWalletSettings) {
                const { secondaryWalletTypes } = response.data.secondaryWalletSettings;
                if (secondaryWalletTypes?.length > 0) {
                    this.context.commit("setCurrentSecondaryWallet", secondaryWalletTypes[0]);
                }
                else {
                    this.context.commit("setCurrentSecondaryWallet", new SecondaryWalletType);
                }
            }

            this.setLoading(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoading(false);
        });
    }

    @Action
    async getGeneralLedgerMappings(id: string) {

        this.setLoading(true);

        await ajax.get(`/portal-backend/fi-api/internal/products/${id}/general-ledger-mapping-defaults`)
        .then(response => {
            // Always expecting an array of length 1 here for default general ledger mappings
            this.context.commit("setGeneralLedgerMappings", response.data.results[0]);
            this.setLoading(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoading(false);
        });
    }

    @Action
    async getGeneralLedgerMappingOverrides(id: string) {

        this.setLoading(true);

        await ajax.get(`/portal-backend/fi-api/internal/products/${id}/general-ledger-mapping-overrides`)
        .then(response => {
            this.context.commit("setGeneralLedgerMappingOverrides", response.data.results);
            this.context.commit("setTotalGeneralLedgerMappingOverridesPages", response.data.records.totalRecords);
            if (response.data.results.length > 0) {
                this.context.commit("setCurrentGeneralLedgerMappingOverride", response.data.results[0]);
            }
            this.setLoading(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoading(false);
        });
    }

    @Action
    async prepareProductViewModel() {
        this.context.commit("setProductViewModel");
    }

    @Action
    async prepareSecondaryWalletTypeViewModel() {
        this.context.commit("setSecondaryWalletTypeViewModel");
    }

    @Action
    async createGeneralLedgerMappingOverrides(request: CreateGeneralLedgerMappingOverridesRequest) {

        this.setLoadingDialog(true);

        await ajax.post(`/portal-backend/fi-api/internal/products/${this.product.id}/general-ledger-mapping-overrides`, request)
        .then(response => {
            this.context.commit("setGeneralLedgerMappingOverrideFromUpdate", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async createProductIssue(request: CreateProductIssueRequest) {

        this.setLoadingDialog(true);

        this.context.commit("setProductIssueIdFromCreate", null);

        await ajax.post(`/portal-backend/fi-api/internal/product-issues`, request)
        .then(response => {
            this.context.commit("setProductIssueIdFromCreate", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async editGeneralSettings() {

        this.setLoadingDialog(true);

        const request = new UpdateProductGeneralSettingsRequest(this.productVM.generalSettings, this.productVM.updatedAt);

        await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/general-settings`, request)
        .then(response => {
            this.context.commit("setProduct", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async editDepositBankSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.depositBankSettingsAvailable) {

            const request = new UpdateDepositBankSettingsRequest(this.productVM.depositBankSettings, this.productVM.updatedAt);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-bank-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-bank-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editDepositCardSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.depositCardSettingsAvailable) {

            const request = new UpdateDepositCardSettingsRequest(this.productVM.depositCardSettings, this.productVM.updatedAt);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-card-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-card-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editGeneralPayeeSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.generalPayeeSettingsAvailable) {

            const request = new UpdateGeneralPayeeSettingsRequest(this.productVM.generalPayeeSettings, this.productVM.updatedAt);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/general-payee-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/general-payee-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editDepositPaymentOrderSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.depositPaymentOrderSettingsAvailable) {

            const request = new UpdateDepositPaymentOrderSettingsRequest(this.productVM.depositPaymentOrderSettings, this.productVM.updatedAt, this.productVM.generalSettings.defaultWalletCurrency);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-payment-order-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-payment-order-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editDepositInterestSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.depositInterestSettingsAvailable) {

            const request = new UpdateDepositInterestSettingsRequest(this.productVM.depositInterestSettings, this.productVM.updatedAt, this.productVM.generalSettings.defaultWalletCurrency);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-interest-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-interest-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editDepositInstantAccessSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.depositInstantAccessSettingsAvailable) {

            const request = new UpdateDepositInstantAccessSettingsRequest(this.productVM.depositInstantAccessSettings, this.productVM.updatedAt, this.productVM.generalSettings.defaultWalletCurrency);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-instant-access-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-instant-access-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editDepositOverdraftSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.depositOverdraftSettingsAvailable) {

            const request = new UpdateDepositOverdraftSettingsRequest(this.productVM.depositOverdraftSettings, this.productVM.updatedAt, this.productVM.generalSettings.defaultWalletCurrency);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-overdraft-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-overdraft-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editDepositOverdraftInterestSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.depositOverdraftInterestSettingsAvailable) {

            const request = new UpdateDepositOverdraftInterestSettingsRequest(this.productVM.depositOverdraftInterestSettings, this.productVM.updatedAt, this.productVM.generalSettings.defaultWalletCurrency);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-overdraft-interest-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-overdraft-interest-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editDepositFixedTermSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.depositFixedTermSettingsAvailable) {

            const request = new UpdateDepositFixedTermSettingsRequest(this.productVM.depositFixedTermSettings, this.productVM.updatedAt, this.productVM.generalSettings.defaultWalletCurrency);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-fixed-term-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-fixed-term-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editDepositFixedTermMaturitySettings() {

        this.setLoadingDialog(true);

        if (this.productVM.depositFixedTermMaturitySettingsAvailable) {

            const request = new UpdateDepositFixedTermMaturitySettingsRequest(this.productVM.depositFixedTermMaturitySettings, this.productVM.updatedAt);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-fixed-term-maturity-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
            }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-fixed-term-maturity-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editDepositCoolingOffSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.depositCoolingOffSettingsAvailable) {

            const request = new UpdateDepositCoolingOffSettingsRequest(this.productVM.depositCoolingOffSettings, this.productVM.updatedAt);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-cooling-off-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
            }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/deposit-cooling-off-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editLendingInterestSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.lendingInterestSettingsAvailable) {

            const request = new UpdateLendingInterestSettingsRequest(this.productVM.lendingInterestSettings, this.productVM.updatedAt);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/lending-interest-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/lending-interest-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editLendingScheduleSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.lendingScheduleSettingsAvailable) {

            const request = new UpdateLendingScheduleSettingsRequest(this.productVM.lendingScheduleSettings, this.productVM.updatedAt);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/lending-schedule-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/lending-schedule-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editLendingTermSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.lendingTermSettingsAvailable) {

            const request = new UpdateLendingTermSettingsRequest(this.productVM.lendingTermSettings, this.productVM.updatedAt, this.productVM.generalSettings.defaultWalletCurrency);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/lending-term-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/lending-term-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editGeneralFeesSettings() {

        this.setLoadingDialog(true);

        if (this.productVM.generalFeeSettingsAvailable) {

            const request = new UpdateGeneralFeeSettingsRequest(this.productVM.generalFeeSettings, this.productVM.updatedAt);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/general-fee-settings`, request)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/general-fee-settings`)
            .then(response => {
                this.context.commit("setProduct", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editGeneralLedgerMappings() {

        this.setLoadingDialog(true);

        // If the generalLedgerMappings ID exists then we are updating the existing settings with PUT
        if (this.generalLedgerMappings.id) {
            const request = new UpdateProductGeneralLedgerSettingsRequest(this.productVM.generalLedgerSettings, this.productVM.updatedAt);

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/general-ledger-mapping-defaults/${this.generalLedgerMappings.id}`, request)
            .then(response => {
                this.context.commit("setGeneralLedgerMappings", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        // Otherwise we need to create them with POST
        else {
            const generalLedgerRequest = new CreateGeneralLedgerMappingsRequest();
            generalLedgerRequest.enabled = this.productVM.generalLedgerSettings.enabled;
            generalLedgerRequest.transactionSourceGLId = this.productVM.generalLedgerSettings.transactionSourceGLId;
            generalLedgerRequest.savingsPortfolioControlGLId = this.productVM.generalLedgerSettings.savingsPortfolioControlGLId;
            generalLedgerRequest.savingsInterestExpenseGLId = this.productVM.generalLedgerSettings.savingsInterestExpenseGLId;
            generalLedgerRequest.savingsInterestPayableGLId = this.productVM.generalLedgerSettings.savingsInterestPayableGLId;
            generalLedgerRequest.savingsFeeIncomeGLId = this.productVM.generalLedgerSettings.savingsFeeIncomeGLId;

            ajax.post(`/portal-backend/fi-api/internal/products/${this.product.id}/general-ledger-mapping-defaults`, generalLedgerRequest)
            .then(response => {
                this.context.commit("setGeneralLedgerMappings", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editGeneralLedgerMappingOverrides(request: UpdateGeneralLedgerMappingOverrideRequest) {

        this.setLoadingDialog(true);

        await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/general-ledger-mapping-overrides/${this.currentGeneralLedgerMappingOverride.id}`, request)
        .then(response => {
            this.context.commit("setGeneralLedgerMappingOverrideFromUpdate", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async createTransactionalFee(request: CreateTransactionalFeeRequest) {

        this.setLoadingDialog(true);
        request.fixedAmount.amount = CurrencyUtils.convertDecimalStringToAmountString(request.fixedAmount.amount);
        request.fixedAmount.currency = this.productVM.generalSettings.defaultWalletCurrency;
        request.percentage = +request.percentage;

        await ajax.post(`/portal-backend/fi-api/internal/products/${this.product.id}/general-fee-settings/transactional-fees`, request)
        .then(response => {
            this.context.commit("setProductTransactionalFeeFromCreate", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async createScheduledFee(request: CreateScheduledFeeRequest) {

        this.setLoadingDialog(true);
        request.periodValue = +request.periodValue
        request.introductoryPeriodValue = +request.introductoryPeriodValue
        request.amount.amount = CurrencyUtils.convertDecimalStringToAmountString(request.amount.amount);
        request.amount.currency = this.productVM.generalSettings.defaultWalletCurrency;
        request.introductoryAmount.amount = CurrencyUtils.convertDecimalStringToAmountString(request.introductoryAmount.amount);
        request.introductoryAmount.currency = this.productVM.generalSettings.defaultWalletCurrency;

        await ajax.post(`/portal-backend/fi-api/internal/products/${this.product.id}/general-fee-settings/scheduled-fees`, request)
        .then(response => {
            this.context.commit("setProductScheduledFeeFromCreate", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async createManualFee(request: CreateManualFeeRequest) {

        this.setLoadingDialog(true);
        request.amount.amount = CurrencyUtils.convertDecimalStringToAmountString(request.amount.amount);
        request.amount.currency = this.productVM.generalSettings.defaultWalletCurrency;

        await ajax.post(`/portal-backend/fi-api/internal/products/${this.product.id}/general-fee-settings/manual-fees`, request)
        .then(response => {
            this.context.commit("setProductManualFeeFromCreate", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async createSecondaryWallet(request: CreateSecondaryWalletTypeRequest) {

        this.setLoadingDialog(true);

        await ajax.post(`/portal-backend/fi-api/internal/products/${this.product.id}/secondary-wallet-settings/secondary-wallet-types`, request)
        .then(response => {
            this.context.commit("setSecondaryWalletFromCreate", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async editTransactionalFee(request: UpdateTransactionalFeeRequest) {

        this.setLoadingDialog(true);

        await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/general-fee-settings/transactional-fees/${request.id}`, request)
        .then(response => {
            this.context.commit("updateTransactionalFee", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async editScheduledFee(request: UpdateScheduledFeeRequest) {

        this.setLoadingDialog(true);

        await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/general-fee-settings/scheduled-fees/${request.id}`, request)
        .then(response => {
            this.context.commit("updateScheduledFee", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async editSecondaryWalletSettings() {

        this.setLoadingDialog(true);
        const request = new UpdateSecondaryWalletSettingsRequest();

        await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/secondary-wallet-settings`, request)
        .then(response => {
            this.context.commit("setProduct", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async editSecondaryWalletTypeGeneralSettings() {

        this.setLoadingDialog(true);
        const request = new UpdateSecondaryWalletTypeGeneralSettingsRequest(this.currentSecondaryWalletTypeViewModel)

        await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/secondary-wallet-settings/secondary-wallet-types/${this.currentSecondaryWalletTypeViewModel.id}/general-settings`, request)
        .then(response => {
            this.context.commit("updateSecondaryWalletGeneralSettings", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async editSecondaryWalletTypeInterestSettings() {

        this.setLoadingDialog(true);

        if (this.currentSecondaryWalletTypeViewModel.depositInterestSettingsAvailable) {

            const request = new UpdateSecondaryWalletTypeInterestSettingsRequest(this.currentSecondaryWalletTypeViewModel);
            request.rateValue = +request.rateValue;
            request.interestBearingThreshold.amount = CurrencyUtils.convertDecimalStringToAmountString(request.interestBearingThreshold.amount);
            // TODO: Support multiple values for interestBearingThreshold if there is more than one allowedCurrencies
            request.interestBearingThreshold.currency = this.currentSecondaryWallet.generalSettings.allowedCurrencies[0];

            await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/secondary-wallet-settings/secondary-wallet-types/${this.currentSecondaryWallet.id}/deposit-interest-settings`, request)
            .then(response => {
                this.context.commit("updateSecondaryWallet", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
        else {
            await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/secondary-wallet-settings/secondary-wallet-types/${this.currentSecondaryWallet.id}/deposit-interest-settings`)
            .then(response => {
                this.context.commit("removeSecondaryWalletTypeInterestSettings", response.data);
                this.setLoadingDialog(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                this.setLoadingDialog(false);
            });
        }
    }

    @Action
    async editManualFee(request: UpdateManualFeeRequest) {

        this.setLoadingDialog(true);

        await ajax.put(`/portal-backend/fi-api/internal/products/${this.product.id}/general-fee-settings/manual-fees/${request.id}`, request)
        .then(response => {
            this.context.commit("updateManualFee", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async deleteTransactionalFee() {

        this.setLoadingDialog(true);

        await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/general-fee-settings/transactional-fees/${this.currentTransactionalFee.id}`)
        .then(response => {
            this.context.commit("removeProductTransactionalFee", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async deleteScheduledFee() {

        this.setLoadingDialog(true);

        await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/general-fee-settings/scheduled-fees/${this.currentScheduledFee.id}`)
        .then(response => {
            this.context.commit("removeProductScheduledFee", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async deleteManualFee() {

        this.setLoadingDialog(true);

        await ajax.delete(`/portal-backend/fi-api/internal/products/${this.product.id}/general-fee-settings/manual-fees/${this.currentManualFee.id}`)
        .then(response => {
            this.context.commit("removeProductManualFee", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async getHistory() {

        this.setLoadingHistory(true);

        await ajax.get(`/portal-backend/fi-api/internal/products/${this.product.id}/history`)
        .then(response => {
            this.context.commit("setHistory", response.data);
            this.setLoadingHistory(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingHistory(false);
        });
    }

    @Action
    async getProductIssues(pageNumber: number) {

        this.setLoadingProductIssues(true);

        await ajax.get(`/portal-backend/fi-api/internal/product-issues?productId=${this.product.id}&pageSize=${this.pageSize}&pageNumber=${pageNumber}`)
        .then(response => {
            this.context.commit("setProductIssues", response.data.results);
            this.context.commit("setProductIssuesTotalPages", response.data.records.totalRecords);
            this.setLoadingProductIssues(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingProductIssues(false);
        });
    }

    @Action
    public async updateCurrentGeneralLedgerMappingOverride(productGeneralLedgerMappingOverride: GeneralLedgerMappingOverride){
        this.context.commit("setCurrentGeneralLedgerMappingOverride", productGeneralLedgerMappingOverride);
    }

    @Action
    public async updateCurrentProductIssue(productIssue: ProductIssue){
        this.context.commit("setCurrentProductIssue", productIssue);
    }

    @Action
    public async updateCurrentTransactionalFee(transactionalFee: TransactionalFee){
        this.context.commit("setCurrentTransactionalFee", transactionalFee);
    }

    @Action
    public async updateCurrentScheduledFee(scheduledFee: ScheduledFee){
        this.context.commit("setCurrentScheduledFee", scheduledFee);
    }

    @Action
    public async updateCurrentManualFee(manualFee: ManualFee){
        this.context.commit("setCurrentManualFee", manualFee);
    }

    @Action
    public async updateCurrentSecondaryWallet(secondaryWallet: SecondaryWalletType){
        this.context.commit("setCurrentSecondaryWallet", secondaryWallet);
    }

    @Action
    async approveProductIssue() {

        this.setLoadingDialog(true);

        await ajax.post(`/portal-backend/fi-api/internal/product-issues/${this.currentProductIssue.id}/approve`)
        .then(response => {
            this.context.commit("setProductIssueFromUpdate", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async cancelProductIssue() {

        this.setLoadingDialog(true);

        await ajax.post(`/portal-backend/fi-api/internal/product-issues/${this.currentProductIssue.id}/cancel`)
        .then(response => {
            this.context.commit("setProductIssueFromUpdate", response.data);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    async getProductAccounts(pageNumber: number) {

        //this.setLoading(true);

        // If UX API Access is allowed, use UX API
        if (AuthModule.me.institution.config.uxApiAccess && PermissionUtils.allowUxApiAccess()) {
            await ajax.get(`/portal-backend/ux-api/accounts?pageSize=${this.pageSize}&pageNumber=${pageNumber}&productId=${this.product.id}`)
            .then(response => {
                this.context.commit("setProductAccounts", response.data.accounts);
                this.context.commit("setProductAccountsTotalPages", response.data.records.totalRecords);
                //this.setLoading(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                //this.setLoading(false);
            });
        }
        // Else get Customer Accounts from FI instead
        else {
            await ajax.get(`/portal-backend/fi-api/accounts?pageSize=${this.pageSize}&pageNumber=${pageNumber}&productId=${this.product.id}`)
            .then(response => {
                this.context.commit("setProductAccounts", response.data.results);
                this.context.commit("setProductAccountsTotalPages", response.data.records.totalRecords);
                //this.setLoading(false);
            })
            .catch(error => {
                AppModule.handleApiError(error);
                //this.setLoading(false);
            });
        }
    }

    @Action
    async getRateSources() {

        this.setLoadingDialog(true);

        await ajax.get(`/portal-backend/fi-api/internal/rate-sources/`)
        .then(response => {
            this.context.commit("setProductDetailsRateSources", response.data.results);
            this.setLoadingDialog(false);
        })
        .catch(error => {
            AppModule.handleApiError(error);
            this.setLoadingDialog(false);
        });
    }

    @Action
    cleanState() {
        this.context.commit("resetState");
    }

    @Mutation
    resetState() {
        this.loading = true;
        this.loadingDialog = false;
        this.loadingHistory = true;
        this.loadingProductIssues = true;
        this.product = new Product();
        this.generalLedgerMappings = new GeneralLedgerMappings();
        this.generalLedgerMappingOverrides = [];
        this.totalGeneralLedgerMappingOverridesPages = 1;
        this.currentGeneralLedgerMappingOverride = new GeneralLedgerMappingOverride();
        this.productVM = new EditProductViewModel();
        this.productFeatureVisibility = new ProductFeatureVisiblity();
        this.productIssues = [];
        this.totalProductIssuesPages = 1;
        this.productAccounts = [];
        this.totalProductAccountsPages = 1;
        this.currentProductIssue = new ProductIssue();
        this.newProductIssueId = null;
        this.currentTransactionalFee = new TransactionalFee();
        this.currentScheduledFee = new ScheduledFee();
        this.currentManualFee = new ManualFee();
        this.totalTransactionalFeesPages = 1;
        this.totalScheduledFeesPages = 1;
        this.totalManualFeesPages = 1;
        this.history = [];
        this.rateSources = [];
        this.currentSecondaryWallet = new SecondaryWalletType();
        this.currentSecondaryWalletTypeViewModel = new SecondaryWalletTypeViewModel(new SecondaryWalletType());
    }

    @Mutation
    private async setLoading(loading: boolean) {
        this.loading = loading;
    }

    @Mutation
    private async setLoadingDialog(loading: boolean) {
        this.loadingDialog = loading;
    }

    @Mutation
    private async setLoadingHistory(loading: boolean) {
        this.loadingHistory = loading;
    }

    @Mutation
    private async setLoadingProductIssues(loading: boolean) {
        this.loadingProductIssues = loading;
    }

    @Mutation
    private async setProduct(product: Product) {
        this.product = product;
        this.productFeatureVisibility = ListUtils.productFeatureVisibility(product.generalSettings.subType);
    }

    @Mutation
    private async setGeneralLedgerMappings(response: GeneralLedgerMappings) {
        if (response) {
            this.generalLedgerMappings = response;
        }
    }

    @Mutation
    private async setGeneralLedgerMappingOverrides(response: GeneralLedgerMappingOverride[]) {
        if (response) {
            this.generalLedgerMappingOverrides = response;
        }
    }

    @Mutation
    private async setTotalGeneralLedgerMappingOverridesPages(total: number) {
        this.totalGeneralLedgerMappingOverridesPages = Math.ceil(total/this.pageSize);
    }

    @Mutation
    private async setGeneralLedgerMappingOverrideFromUpdate(response: GeneralLedgerMappingOverride) {
        // First set the updated or new mapping override as the current one
        this.currentGeneralLedgerMappingOverride = response;
        // Then check the list of all mapping overrides to see if we have a match for this one
        const index = this.generalLedgerMappingOverrides.findIndex((findOverride: GeneralLedgerMappingOverride) => response.id === findOverride.id);
        // If it exists then splice in the newly updated data, if not then add it to the start of the list as new
        if (index) {
            this.generalLedgerMappingOverrides.splice(index, 1, response);
        }
        else {
            this.generalLedgerMappingOverrides.unshift(response);
        }
    }

    @Mutation
    private async setProductIssueIdFromCreate(id: string) {
        this.newProductIssueId = id;
    }

    @Mutation
    private async setProductTransactionalFeeFromCreate(transactionalFee: TransactionalFee) {
        this.product.generalFeeSettings.transactionalFees.unshift(transactionalFee);
    }

    @Mutation
    private async setProductScheduledFeeFromCreate(scheduledFee: ScheduledFee) {
        this.product.generalFeeSettings.scheduledFees.unshift(scheduledFee);
    }

    @Mutation
    private async setProductManualFeeFromCreate(manualFee: ManualFee) {
        this.product.generalFeeSettings.manualFees.unshift(manualFee);
    }

    @Mutation
    private async setSecondaryWalletFromCreate(secondaryWallet: SecondaryWalletType) {
        this.product.secondaryWalletSettings.secondaryWalletTypes.unshift(secondaryWallet);
        this.currentSecondaryWallet = secondaryWallet;
    }

    @Mutation
    public async updateTransactionalFee(transactionalFee: TransactionalFee){
        const feeIndex = this.product.generalFeeSettings.transactionalFees.findIndex(fee => fee.id === transactionalFee.id)
        this.product.generalFeeSettings.transactionalFees[feeIndex] = transactionalFee;
    }

    @Mutation
    public async updateScheduledFee(scheduledFee: ScheduledFee){
        const feeIndex = this.product.generalFeeSettings.scheduledFees.findIndex(fee => fee.id === scheduledFee.id)
        this.product.generalFeeSettings.scheduledFees[feeIndex] = scheduledFee;
    }

    @Mutation
    public async updateManualFee(manualFee: ManualFee){
        const feeIndex = this.product.generalFeeSettings.manualFees.findIndex(fee => fee.id === manualFee.id)
        this.product.generalFeeSettings.manualFees[feeIndex] = manualFee;
    }

    @Mutation
    public async updateSecondaryWallet(secondaryWallet: SecondaryWalletType){
        const walletIndex = this.product.secondaryWalletSettings.secondaryWalletTypes.findIndex(wallet => wallet.id === secondaryWallet.id)
        this.product.secondaryWalletSettings.secondaryWalletTypes[walletIndex] = secondaryWallet;
        this.currentSecondaryWallet = secondaryWallet;
    }

    @Mutation
    public async updateSecondaryWalletGeneralSettings(secondaryWallet: SecondaryWalletType){
        const walletIndex = this.product.secondaryWalletSettings.secondaryWalletTypes.findIndex(wallet => wallet.id === secondaryWallet.id)
        this.product.secondaryWalletSettings.secondaryWalletTypes[walletIndex].generalSettings = secondaryWallet.generalSettings;
        this.currentSecondaryWallet.generalSettings = secondaryWallet.generalSettings;
    }

    @Mutation
    private async removeProductTransactionalFee(transactionalFee: TransactionalFee) {
        this.product.generalFeeSettings.transactionalFees = this.product.generalFeeSettings.transactionalFees.filter(fee => fee.id !== transactionalFee.id)
        this.currentTransactionalFee = new TransactionalFee();
    }

    @Mutation
    private async removeProductScheduledFee(scheduledFee: ScheduledFee) {
        this.product.generalFeeSettings.scheduledFees = this.product.generalFeeSettings.scheduledFees.filter(fee => fee.id !== scheduledFee.id)
        this.currentScheduledFee = new ScheduledFee();
    }

    @Mutation
    private async removeProductManualFee(manualFee: ManualFee) {
        this.product.generalFeeSettings.manualFees = this.product.generalFeeSettings.manualFees.filter(fee => fee.id !== manualFee.id)
        this.currentManualFee = new ManualFee();
    }

    @Mutation
    private async removeSecondaryWalletTypeInterestSettings(secondaryWallet: SecondaryWalletType){
        const walletIndex = this.product.secondaryWalletSettings.secondaryWalletTypes.findIndex(wallet => wallet.id === secondaryWallet.id)
        this.product.secondaryWalletSettings.secondaryWalletTypes[walletIndex].depositInterestSettings = undefined;
    }

    @Mutation
    private async setHistory(response: GetHistoryResponse) {
        const history = HistoryUtils.cleanHistory(response);
        this.history = history;
    }


    @Mutation
    private async setProductIssues(response: ProductIssue[]) {
        this.productIssues = response;
        if (this.productIssues.length > 0) {
            this.currentProductIssue = this.productIssues[0];
        }
    }

    @Mutation
    private async setProductIssuesTotalPages(total: number) {
        this.totalProductIssuesPages = Math.ceil(total/this.pageSize);
    }

    @Mutation
    private async setCurrentProductIssue(productIssue: ProductIssue) {
        this.currentProductIssue = productIssue;
    }

    @Mutation
    private async setCurrentGeneralLedgerMappingOverride(generalLedgerMappingOverride: GeneralLedgerMappingOverride) {
        this.currentGeneralLedgerMappingOverride = generalLedgerMappingOverride;
    }

    @Mutation
    private async setCurrentTransactionalFee(transactionalFee: TransactionalFee) {
        this.currentTransactionalFee = transactionalFee;
    }

    @Mutation
    private async setCurrentScheduledFee(scheduledFee: ScheduledFee) {
        this.currentScheduledFee = scheduledFee;
    }

    @Mutation
    private async setCurrentManualFee(manualFee: ManualFee) {
        this.currentManualFee = manualFee;
    }

    @Mutation
    private async setTransactionalFeesTotalPages(total: number) {
        this.totalTransactionalFeesPages = Math.ceil(total/this.pageSize);
    }

    @Mutation
    private async setScheduledFeesTotalPages(total: number) {
        this.totalScheduledFeesPages = Math.ceil(total/this.pageSize);
    }

    @Mutation
    private async setManualFeesTotalPages(total: number) {
        this.totalManualFeesPages = Math.ceil(total/this.pageSize);
    }

    @Mutation
    private async setCurrentSecondaryWallet(secondaryWallet: SecondaryWalletType) {
        this.currentSecondaryWallet = secondaryWallet;
    }

    @Mutation
    private async setProductIssueFromUpdate(productIssue: ProductIssue) {
        this.currentProductIssue = productIssue;
        const index = this.productIssues.findIndex((findPI: ProductIssue) => productIssue.id === findPI.id);
        this.productIssues.splice(index, 1, productIssue);
    }

    @Mutation
    private async setProductViewModel() {
        const productCopy = JSON.parse(JSON.stringify(this.product));
        const generalLedgerMappingCopy = JSON.parse(JSON.stringify(this.generalLedgerMappings));
        this.productVM = new EditProductViewModel();
        this.productVM.updatedAt = productCopy.updatedAt;
        this.productVM.generalSettings = productCopy.generalSettings;

        if (productCopy.generalFeeSettings) {
            this.productVM.generalFeeSettings = productCopy.generalFeeSettings
            this.productVM.generalFeeSettingsAvailable = true;
        }
        else {
            this.productVM.generalFeeSettings = new GeneralFeeSettings();
        }

        if (productCopy.generalPayeeSettings) {
            this.productVM.generalPayeeSettings = productCopy.generalPayeeSettings
            this.productVM.generalPayeeSettingsAvailable = true;
        }
        else {
            this.productVM.generalPayeeSettings = new GeneralPayeeSettings();
        }

        // Checking for empty object when checking if mapping settings exist (instead of a simple undefined check like we have for other product settings)
        //if (Object.keys(this.generalLedgerMappings).length !== 0) {

        // Or should this be checking the "state" field to see if it is "DELETED" or "ACTIVE" instead of checking for length?
        // What if nothing is there at all like in the case of the first set up?
        if (this.generalLedgerMappings.state === 'ACTIVE') {
            this.productVM.generalLedgerSettings = generalLedgerMappingCopy;
            this.productVM.generalLedgerSettingsAvailable = true;
        }
        else {
            this.productVM.generalLedgerSettings = new ProductGeneralLedgerSettings();
        }

        if (productCopy.depositBankSettings) {
            this.productVM.depositBankSettings = productCopy.depositBankSettings
            this.productVM.depositBankSettingsAvailable = true;
        }
        else {
            this.productVM.depositBankSettings = new DepositBankSettings();
        }

        if (productCopy.depositCardSettings) {
            this.productVM.depositCardSettings = productCopy.depositCardSettings
            this.productVM.depositCardSettingsAvailable = true;
        }
        else {
            this.productVM.depositCardSettings = new DepositCardSettings();
        }

        if (productCopy.depositPaymentOrderSettings) {
            this.productVM.depositPaymentOrderSettings = productCopy.depositPaymentOrderSettings
            this.productVM.depositPaymentOrderSettingsAvailable = true;
        }
        else {
            this.productVM.depositPaymentOrderSettings = new DepositPaymentOrderSettings();
        }

        if (productCopy.depositInterestSettings) {
            this.productVM.depositInterestSettings = productCopy.depositInterestSettings
            this.productVM.depositInterestSettingsAvailable = true;
        }
        else {
            this.productVM.depositInterestSettings = new DepositInterestSettings();
        }

        if (productCopy.depositInstantAccessSettings) {
            this.productVM.depositInstantAccessSettings = productCopy.depositInstantAccessSettings
            this.productVM.depositInstantAccessSettingsAvailable = true;
        }
        else {
            this.productVM.depositInstantAccessSettings = new DepositInstantAccessSettings();
        }

        if (productCopy.depositOverdraftSettings) {
            this.productVM.depositOverdraftSettings = productCopy.depositOverdraftSettings
            this.productVM.depositOverdraftSettingsAvailable = true;
        }
        else {
            this.productVM.depositOverdraftSettings = new DepositOverdraftSettings();
        }

        if (productCopy.depositOverdraftInterestSettings) {
            this.productVM.depositOverdraftInterestSettings = productCopy.depositOverdraftInterestSettings
            this.productVM.depositOverdraftInterestSettingsAvailable = true;
        }
        else {
            this.productVM.depositOverdraftInterestSettings = new DepositOverdraftInterestSettings();
        }

        if (productCopy.depositFixedTermSettings) {
            this.productVM.depositFixedTermSettings = productCopy.depositFixedTermSettings
            this.productVM.depositFixedTermSettingsAvailable = true;
        }
        else {
            this.productVM.depositFixedTermSettings = new DepositFixedTermSettings();
        }

        if (productCopy.depositFixedTermMaturitySettings) {
            this.productVM.depositFixedTermMaturitySettings = productCopy.depositFixedTermMaturitySettings
            this.productVM.depositFixedTermMaturitySettingsAvailable = true;
        }
        else {
            this.productVM.depositFixedTermMaturitySettings = new DepositFixedTermMaturitySettings();
        }

        if (productCopy.depositCoolingOffSettings) {
            this.productVM.depositCoolingOffSettings = productCopy.depositCoolingOffSettings
            this.productVM.depositCoolingOffSettingsAvailable = true;
        }
        else {
            this.productVM.depositCoolingOffSettings = new DepositCoolingOffSettings();
        }

        if (productCopy.lendingBankSettings) {
            this.productVM.lendingBankSettings = productCopy.lendingBankSettings
            this.productVM.lendingBankSettingsAvailable = true;
        }
        else {
            this.productVM.lendingBankSettings = new LendingBankSettings();
        }

        if (productCopy.lendingCardSettings) {
            this.productVM.lendingCardSettings = productCopy.lendingCardSettings
            this.productVM.lendingCardSettingsAvailable = true;
        }
        else {
            this.productVM.lendingCardSettings = new LendingCardSettings();
        }

        if (productCopy.lendingInterestSettings) {
            this.productVM.lendingInterestSettings = productCopy.lendingInterestSettings
            this.productVM.lendingInterestSettingsAvailable = true;
        }
        else {
            this.productVM.lendingInterestSettings = new LendingInterestSettings();
        }

        if (productCopy.lendingScheduleSettings) {
            this.productVM.lendingScheduleSettings = productCopy.lendingScheduleSettings
            this.productVM.lendingScheduleSettingsAvailable = true;
        }
        else {
            this.productVM.lendingScheduleSettings = new LendingScheduleSettings();
        }

        if (productCopy.lendingTermSettings) {
            this.productVM.lendingTermSettings = productCopy.lendingTermSettings
            this.productVM.lendingTermSettingsAvailable = true;
        }
        else {
            this.productVM.lendingTermSettings = new LendingTermSettings();
        }

        if (productCopy.lendingRepaymentPlanSettings) {
            this.productVM.lendingRepaymentPlanSettings = productCopy.lendingRepaymentPlanSettings
            this.productVM.lendingRepaymentPlanSettingsAvailable = true;
        }
        else {
            this.productVM.lendingRepaymentPlanSettings = new LendingRepaymentPlansSettings();
        }

        if (productCopy.secondaryWalletSettings) {
            this.productVM.secondaryWalletSettings = productCopy.secondaryWalletSettings;
            this.productVM.secondaryWalletSettingsAvailable = true;
        }
        else {
            this.productVM.secondaryWalletSettings = new SecondaryWalletSettings();
        }
    }

    @Mutation
    private async setSecondaryWalletTypeViewModel() {
        const currentSecondaryWalletCopy = JSON.parse(JSON.stringify(this.currentSecondaryWallet));
        this.currentSecondaryWalletTypeViewModel = new SecondaryWalletTypeViewModel(currentSecondaryWalletCopy);
    }

    @Mutation
    private async setProductDetailsRateSources(rateSources: RateSource[]) {
        if (rateSources) {
            this.rateSources = rateSources;
        }
    }

    @Mutation
    private async setProductAccounts(response: CustomerAccountSummary[]) {
        if (response) {
            this.productAccounts = response;
        }
    }

    @Mutation
    private async setProductAccountsTotalPages(total: number) {
        this.totalProductAccountsPages = Math.ceil(total/this.pageSize);
    }

}

export const ProductDetailsModule = getModule(ProductDetailsStore);